import { render } from "./AuthAction.vue?vue&type=template&id=7fd0efa4"
import script from "./AuthAction.vue?vue&type=script&lang=js"
export * from "./AuthAction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__